import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigProvider as ANTDThemeProvider } from 'antd';
import { useMemo } from 'react';
import { ThemeProvider as SCThemeProvider, useTheme, } from 'styled-components';
import { applyThemeForAntd } from './AntdThemeConfig/AntdThemeConfig';
export const ThemeProvider = ({ children, theme, }) => {
    const antdTheme = useMemo(() => {
        return applyThemeForAntd(theme);
    }, [theme]);
    return (_jsx(ANTDThemeProvider, { theme: antdTheme, children: _jsx(SCThemeProvider, { theme: theme, children: children }) }));
};
export { useTheme };
//# sourceMappingURL=Provider.js.map